import { createContext, useContext, useMemo, useState } from "react";

export type LoyaltyDataType = {
  points: number | null;
  userTier: string | null;
  isActive: boolean;
};

const HeaderContext = createContext<
  | {
      hoveredIndex: number | null;
      setHoveredIndex: React.Dispatch<React.SetStateAction<number | null>>;
      loyaltyPoints: number | null;
      isLoyaltyActive: boolean;
      userTier: string | null;
      setLoyaltyData: React.Dispatch<React.SetStateAction<LoyaltyDataType>>;
      onClick: () => void;
    }
  | undefined
>(undefined);

const HeaderProvider = ({ children }: { children: React.ReactNode }) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [loyaltyData, setLoyaltyData] = useState<LoyaltyDataType>({ points: null, userTier: null, isActive: false });

  const onClick = () => {
    setHoveredIndex(null);
  };

  const contextValues = useMemo(
    () => ({
      hoveredIndex,
      setHoveredIndex,
      isLoyaltyActive: loyaltyData.isActive,
      userTier: loyaltyData.userTier,
      loyaltyPoints: loyaltyData.points,
      setLoyaltyData,
      onClick,
    }),
    [hoveredIndex, loyaltyData.isActive, loyaltyData.points, loyaltyData.userTier]
  );

  return <HeaderContext.Provider value={contextValues}>{children}</HeaderContext.Provider>;
};

const useHeaderContext = () => {
  const context = useContext(HeaderContext);

  if (context === undefined) {
    throw new Error("headerContext must be used within a HeaderProvider");
  }

  return context;
};

export { HeaderProvider, useHeaderContext };
